import {
  FormSingleSelectField,
  FormSingleSelectFieldProps,
} from "@avamae/formbuilder";
import { useField, useFormikContext } from "formik";
import React, { useEffect } from "react";

type additionalProps = {
  onChange?: (
    values: any,
    setFieldValue?: (field: string, value: any) => void
  ) => void;
  containerStyle?: React.CSSProperties;
};
export const WrappedFormSingleSelectField = function<T>({
  onChange,
  containerStyle,
  ...props
}: FormSingleSelectFieldProps<T> & additionalProps) {
  const [, formikMeta, formikHelpers] = useField(props.fieldName);
  const { setFieldValue } = useFormikContext();
  const hasError = formikMeta.error;

  useEffect(() => {
    if (onChange) {
      onChange(formikMeta.value, setFieldValue);
    }
  }, [formikMeta.value, onChange, setFieldValue]);
  return (
    <div
      className={`DropdownContainer ${
        hasError && formikMeta.touched ? "ErrorField" : ""
      }`}
      onBlur={() => formikHelpers.setTouched(true)}
      style={containerStyle}
    >
      <FormSingleSelectField<T> {...props} />
    </div>
  );
};
